module.exports.version = 'v11.7.6-2e0487b3';
